<template lang="pug" >
  tbody.table__body(:class="classes")
    template(v-if="!loading")
      tr.table__body--empty(
        v-if="empty || noPermissions"
        :class="{ 'table__body--grid-item': outsideTable }")
        td(:colspan="cols")
          h2 {{ tableText }}
      slot(
        v-else
        :toggleRow="toggleRow"
        :isToggled="isToggled")
    template(v-else)
      tr.table__row(v-for="r in 7")
        td.table__cell(v-for="i in cols")
          .skeleton
</template>

<script>
export default {
  name: 'VTableBody',

  props: {
    cols: {
      type: Number,
      default: 1
    },
    outsideTable: Boolean,
    empty: Boolean,
    noPermissions: Boolean,
    loading: Boolean,
    labelEmpty: {
      type: String,
      default: 'base.table_is_empty'
    }
  },

  data: () => ({
    toggledId: null
  }),

  computed: {
    classes () {
      return {
        'table__body--grid': this.outsideTable
      }
    },

    tableText () {
      if (this.noPermissions) {
        return 'Немає прав на перегляд'
      }
      return this.$t(this.labelEmpty)
    }
  },

  methods: {
    toggleRow (item) {
      this.toggledId = this.toggledId !== item.id
        ? item.id
        : null
    },

    isToggled (item) {
      return this.toggledId === item.id
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';
  @import '@/sass/abstracts/_mixins.scss';

  .table__body--empty {
    height: 38.5rem;
    background-color: $color-white;
    border-top: .1rem solid $table-border-color;

    td {
      text-align: center;
    }

    h2 {
      color: $color-gray-light-1;
      font-weight: 600;
      margin-bottom: 2.5rem;
    }
  }

  .table__body--grid {
    display: grid;
    gap: 1rem;
  }

  .table__body--grid-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .table__body {
    .skeleton {
      width: 100%;
      height: 2rem;
      border-radius: .8rem;
      @include skeleton;
    }
  }
</style>
